import React, { Component } from 'react';
import RootRouter from './router';
import send from './utils/send';
import { ORG_CODE, SETTLEMENTDATE } from './cache';
import { Toast } from 'antd-mobile';
import { FARM_ORG } from './cache';
import 'antd-mobile/dist/antd-mobile.css';
import './common/css/custom.css';
import './index';
import loseImg from './assets/image/lose.png';
import auth from './utils/auth';

class App extends Component {
  async componentDidMount() {
    if (!FARM_ORG) {
      return;
    }
    Toast.loading('正在加载', 2);
    // 请求月结日期
    send({
      url: '/api/ifarm/v1/swine/edit_table_time',
      method: 'POST'
    })
      .then((res) => {
        SETTLEMENTDATE.timeStamp = res.data.period;
        const accountDate = new Date(SETTLEMENTDATE.timeStamp);
        const limitDate = new Date(
          //  可操作 > = 月结日。包含月结当前。
          new Date(SETTLEMENTDATE.timeStamp).setDate(accountDate.getDate())
        );

        SETTLEMENTDATE.limitDate = limitDate;
        setTimeout(Toast.hide, 20);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className="App">
        {!!FARM_ORG ? (
          <RootRouter />
        ) : (
          <div>
            <div style={{ marginTop: '80px', textAlign: 'center' }}>
              <img src={loseImg} width="221" height="240"></img>
            </div>
            <div style={{ textAlign: 'center' }}>
              <span
                style={{
                  fontSize: '18px',
                  lineHeight: 2,
                  color: '#000'
                }}
              >
                您还未绑定农场
              </span>
            </div>
            <div style={{ textAlign: 'center' }}>
              <span style={{ fontSize: '14px', color: '#ccc', lineHeight: 2 }}>世界上最遥远的距离莫过于此</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default App;
